import { useVeltClient, VeltSidebarButton, VeltHuddle, VeltPresence, VeltCommentTool, VeltHuddleTool } from '@veltdev/react';
import { useEffect, useState } from 'react';

export default function YourDocument() {

  // Get the Velt client
  const { client } = useVeltClient();

  useEffect(() => {
    if (client) {
      // Set a document ID
      client.setDocumentId('trump-velt-demo-id');
      const selectionElement = client.getSelectionElement();
      selectionElement.enableLiveSelection();
    }
  }, [client]);

  return (
    <>
  <meta charSet="utf-8" />
  <meta name="viewport" content="width=device-width" />
  <meta
    name="viewport"
    content="width=device-width, initial-scale=1.0, viewport-fit=cover"
  />
  <meta
    name="apple-mobile-web-app-status-bar-style"
    content="black-translucent"
  />
  <meta name="apple-mobile-web-app-capable" content="yes" />
  <title>Google Deal</title>
  <meta name="robots" content="index,follow" />
  <meta name="googlebot" content="index,follow" />
  <meta property="og:title" content="Google Deal" />
  <meta property="og:description" content="Google Deal" />
  <meta property="og:type" content="website" />
  <meta
    property="og:image"
    content="https://sendtrumpet.io/api/generate?bg=&bgColor=transparent&logo=https%3A%2F%2Fasset.brandfetch.io%2Fid6O2oGzv-%2FidvNIQR3p7.svg&secondLogoImage=https%3A%2F%2Fasset.brandfetch.io%2FidcY5Nkzv5%2FidWBzmYyDx.png&title=%20Intro%20to%20trumpet&layoutStyle="
  />
  <meta
    property="og:image"
    content="https://sendtrumpet.io/api/6578210b6f9968c763e6fa3e/og"
  />
  <meta property="og:site_name" content="trumpet" />
  <meta charSet="utf-8" />
  <meta name="viewport" content="width=device-width" />
  <meta name="next-head-count" content={12} />
  <noscript data-n-css="" />
  <div id="__next" data-reactroot="">
    <div className="sc-7652c773-0 waIQr">
      <main className="sc-7652c773-1 gxmkzI">
        <section className="sc-7652c773-2 cXSXfh">
          <div className="sc-51ef7276-0 sc-e7e106a7-0 hFuWPD ceoFtL">
            <div className="sc-a5163bdb-2 sc-f4b73b6-7 cMCpug eExoeu">
              <header data-velt-comment-disabled className="sc-79a25a24-0 sc-7f338c96-0 hXtvzn gzTxdL">
                <div className="sc-7f338c96-1 iWJyrB">
                  <p className="sc-6d1fb138-19 sc-79a25a24-3 sc-7f338c96-2 dJiXxj ktSmlU">
                    Google Deal
                  </p>
                </div>
                <div className="sc-f87886bd-0 caOTms">
                  <div style={{display:"flex", marginTop:"4px", gap:"6px"}} lassName="sc-51ef7276-0 hFuWPD">
                    <VeltPresence flockMode={true}/>
                    <VeltCommentTool/>
                    <VeltHuddleTool/>
                    <VeltSidebarButton/>
                  </div>
                  <div className="sc-f87886bd-0 dlhlvA">
                    <cord-sidebar-launcher
                      buffer-events="false"
                      label="COMMENT"
                      inbox-badge-style="badge"
                    />
                  </div>
                  <div className="sc-f87886bd-0 dlhlvA">
                    <button role="button" className="sc-775e4232-2 kKyMSM">
                      <div className="sc-775e4232-4 lcGxJg">
                        <svg
                          width={16}
                          height={16}
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M9.78034 2.05085C9.95188 1.96694 10.1562 1.98809 10.307 2.10533L14.807 5.60533C14.9242 5.69653 14.9949 5.83514 14.9997 5.98361C15.0046 6.13207 14.9432 6.27502 14.8322 6.37371L10.3322 10.3737C10.185 10.5045 9.9748 10.5368 9.79518 10.4561C9.61557 10.3755 9.50001 10.1969 9.50001 10V8.0563C9.2643 8.09693 8.9558 8.16679 8.59562 8.28685C7.72298 8.57773 6.54248 9.16464 5.35356 10.3536C5.20471 10.5024 4.97857 10.5421 4.78793 10.4528C4.5973 10.3635 4.48301 10.1644 4.50206 9.95474C4.64499 8.38259 5.10338 7.23727 5.72601 6.41126C6.34877 5.58508 7.11343 5.10809 7.82119 4.83704C8.41128 4.61105 8.96247 4.52766 9.36537 4.5002C9.41219 4.49701 9.45712 4.49456 9.50001 4.49274V2.5C9.50001 2.30904 9.60879 2.13475 9.78034 2.05085ZM2 5.5C2 4.11929 3.11929 3 4.5 3H6.5C6.77614 3 7 3.22386 7 3.5C7 3.77614 6.77614 4 6.5 4H4.5C3.67157 4 3 4.67157 3 5.5V11.5C3 12.3284 3.67157 13 4.5 13H10.5C11.3284 13 12 12.3284 12 11.5V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V11.5C13 12.8807 11.8807 14 10.5 14H4.5C3.11929 14 2 12.8807 2 11.5V5.5Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                      <span className="sc-775e4232-1 cTTLDF">Share</span>
                    </button>
                    
                  </div>
                </div>
              </header>
              <div
                className="sc-f4b73b6-4 kNBUBa"
                style={{ height: "100%", paddingTop: 47 }}
              >
                <div id="live-container" className="sc-f4b73b6-5 jMXaSv">
                  <div
                    className="sc-f4b73b6-3 jtwykR"
                    style={{
                      opacity: 1,
                      transition:
                        "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
                    }}
                  >
                    <div className="sc-aefe42f7-0 dcdUCL">
                      <div
                        id="widgets-live-content"
                        className="sc-a5163bdb-5 sc-f4b73b6-9 ftMSPs bqABbs"
                      >
                        <cord-presence-observer
                          buffer-events="false"
                          location='{"section":"livepod","component":"company-company-1"}'
                        >
                          <div
                            id="company-1"
                            className="sc-b8209179-0 sc-38009e75-0 hOdVfO"
                            style={{ marginBottom: "2rem" }}
                          >
                            <div className="sc-b8209179-1 sc-38009e75-1 jcukRr">
                              <div className="sc-746af168-0 itgzlH widget-container">
                                <div style={{ width: 1, height: 1 }} />
                                <div className="sc-9b97bd27-0 iFgbpX">
                                  <div className="sc-f87886bd-0 gfJjOg">
                                    <div className="sc-51ef7276-0 sc-2b5a7f36-0 hFuWPD fhiSyZ pod-header-logo-reset">
                                      <div
                                        className="sc-76ec0e49-3 gRhSJE sc-489f2077-5 cfigiV"
                                        style={{ width: "auto" }}
                                      >
                                        <button
                                          id="image-container"
                                          className="sc-489f2077-1 kjUYFa sc-f4315155-0 hVusKN"
                                        >
                                          <img
                                            src="https://asset.brandfetch.io/id6O2oGzv-/idvNIQR3p7.svg"
                                            alt=""
                                            id="image-element"
                                            className="sc-489f2077-0 gXNBXi"
                                            style={{ cursor: "inherit" }}
                                          />
                                          <img
                                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAA6RJREFUaEPtWk1rE0EYngldSyXFS61BPFgQ61EwetBDsjXFgwiKPdhb79KDJ9EiJkiF/gd78CD1UPEHJE02xJMN+hOqHkQtKCUlMW7JmNlk193N7Mw7s5s1FecSSOadeZ73eT9mdoPRIR/4kONHkRHYzaWz1BkdlMhiQjJ9x1jfIYQM21EE42oCdYzjpbrzXRgnhiJAQfcBP1YBQTAuULsTpbd5FXtqo0SAAicEU9C2h1X3t+zCEJEm8O3qxUpUwP2sKRFZNcAEovY6TzKMiQ7NERCBPnjq+dgGlISQwNfcpTwmRClJQ7A1pre2dYg9l8Cog+dWoYjCxq710GoF9rytTqACitXGwJhYtd2fhHbPsLzGDklp8IEKKISOBRxaORgVTQk8k4AseGi1YCVkf68MNGFZawyE0N79mZ12feo0qAJI1GvIeipzPATM4lgWYWzV+8aLM+jgUzJwzTCeVwEaZOMlUNI8x4SftRRqvUkN2Kq0/ChBu9fiEqATWSSmt7aFDXBYgP3rOkDc4eOfREOpVUtZITVK3vdUIbN4JN8t0NwjQ7N46sOxtZ2ZuLwL2eePAr74DzA2tJwJOqPY9nOr+wQCBDqHYGRUHiYdDHIECNG1+QOpq+B/AgxpyitJx/FuBYRSazlTuvpErQDl888SEN91RyAHeAoACOCCNv9L6hFIfCEE6APdLvbXCQSXUQCBcvtk9dr1j9DblVU/5lYbYMUIxhlM+M+alAi8M6fQevMsop+IYL2+uCnVC6BNSn+6X1EmQDcxS9pAKV1vzqJnzVk3BqN+55VUN4YSgORLokP00qNJx4G++4D3PMQA38MyBBVyTxrZTqJ3F+ENdw/wHOZsI1uFu3uXeyETNCImoRI+TAL3Xl95X2unzos8EaUSEPB0P3/4MAmkNxayCBOhlA5Bggv1xU1wpfE7Bgre38DsdZhnm/TGgvBu4AFCrOf8hkx1oo7SmhfyE1+W7ZchXNFZ3mcqYK+Sfnlb3Jn9W/aI0MEkY6lL3yn4Lk7jP26i8e+3OOnmvQO4JwaeLqVDib09+NEij0SQ97kK0B+lQwmU+cGT2CRIobwyGZhjwvN93CQovaOfH6Cx1jnacLjghQo4+SCb1CGVoOYTu0vPa8s3lkRLCRVwkZArr6Kdeb9LlGYwgdjUkOzw0gSGRMTonq+qKg1RmUBERChw2smVj+ehCXhyxP3iG1t/Nxj4q4E1PyRoUCMLk4Nx2kamQJyg3Xv9BsUn30B+762FAAAAAElFTkSuQmCC"
                                            id="image-element-svg"
                                            className="sc-489f2077-0 kVDrXU"
                                            style={{
                                              maxHeight: "5.5rem",
                                              display: "none"
                                            }}
                                          />
                                        </button>
                                      </div>
                                    </div>
                                    <div className="sc-51ef7276-0 sc-2b5a7f36-0 hFuWPD fhiSyZ pod-header-logo-reset">
                                      <div
                                        className="sc-76ec0e49-3 gRhSJE sc-489f2077-5 cfigiV"
                                        style={{ width: "auto" }}
                                      >
                                        <button
                                          id="image-container"
                                          className="sc-489f2077-1 kjUYFa sc-f4315155-0 hVusKN"
                                        >
                                          <img
                                            src="https://asset.brandfetch.io/idcY5Nkzv5/idWBzmYyDx.png"
                                            alt=""
                                            id="image-element"
                                            className="sc-489f2077-0 lkXHej"
                                            style={{ cursor: "inherit" }}
                                          />
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    id="name-company-widget"
                                    className="sc-ce447d5d-1 jtwkdv sc-f4315155-2 hWGmoI"
                                  >
                                    <div
                                      spellCheck="true"
                                      className="sc-ce447d5d-2 fsmvhR"
                                      data-slate-editor="true"
                                      data-slate-node="value"
                                      contentEditable="false"
                                      zindex={-1}
                                      style={{
                                        position: "relative",
                                        outline: "none",
                                        whiteSpace: "pre-wrap",
                                        overflowWrap: "break-word"
                                      }}
                                    >
                                      <h2
                                        data-slate-node="element"
                                        style={{
                                          textAlign: "center",
                                          fontFamily: "AeonikTRIAL-Regular",
                                          fontSize: 48
                                        }}
                                      >
                                        <span data-slate-node="text">
                                          <span
                                            data-slate-leaf="true"
                                            className="sc-5fc0b980-0 fSzefS"
                                            style={{
                                              color: "rgb(255, 255, 255)"
                                            }}
                                          >
                                            <span data-slate-string="true">
                                              Intro to trumpet
                                            </span>
                                          </span>
                                        </span>
                                      </h2>
                                    </div>
                                  </div>
                                  <div
                                    id="description-company-widget"
                                    className="sc-ce447d5d-1 jtwkdv sc-f4315155-3 dDvGpV"
                                  >
                                    <div
                                      spellCheck="true"
                                      className="sc-ce447d5d-2 fsmvhR"
                                      data-slate-editor="true"
                                      data-slate-node="value"
                                      contentEditable="false"
                                      zindex={-1}
                                      style={{
                                        position: "relative",
                                        outline: "none",
                                        whiteSpace: "pre-wrap",
                                        overflowWrap: "break-word"
                                      }}
                                    >
                                      <p
                                        data-slate-node="element"
                                        style={{
                                          margin: 0,
                                          textAlign: "center",
                                          fontFamily: "AeonikTRIAL-Regular",
                                          fontSize: 16
                                        }}
                                      >
                                        <span data-slate-node="text">
                                          <span
                                            data-slate-leaf="true"
                                            className="sc-5fc0b980-0 fSzefS"
                                            style={{
                                              color: "rgb(255, 255, 255)"
                                            }}
                                          >
                                            <span data-slate-string="true">
                                              Hey 👋. Here's a quick intro to
                                              trumpet for you. Enjoy!
                                            </span>
                                          </span>
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div style={{ width: 1, height: 1 }} />
                              </div>
                            </div>
                          </div>
                        </cord-presence-observer>
                        <cord-presence-observer
                          buffer-events="false"
                          location='{"section":"livepod","component":"about-about-8ebc440b-5b8a-4825-8551-bcadba75c5e8"}'
                        >
                          <div
                            id="about-8ebc440b-5b8a-4825-8551-bcadba75c5e8"
                            className="sc-b8209179-0 sc-38009e75-0 dVWbqJ"
                            style={{ marginBottom: "2rem" }}
                          >
                            <div className="sc-b8209179-1 sc-38009e75-1 jcukRr">
                              <div className="sc-746af168-0 bFjxJj widget-container">
                                <div style={{ width: 1, height: 1 }} />
                                <div
                                  id="title-about-widget"
                                  className="sc-ce447d5d-1 jtwkdv sc-79126d1b-2 vyTsQ"
                                >
                                  <div
                                    spellCheck="true"
                                    className="sc-ce447d5d-2 fsmvhR"
                                    data-slate-editor="true"
                                    data-slate-node="value"
                                    contentEditable="false"
                                    zindex={-1}
                                    style={{
                                      position: "relative",
                                      outline: "none",
                                      whiteSpace: "pre-wrap",
                                      overflowWrap: "break-word"
                                    }}
                                  >
                                    <h2
                                      data-slate-node="element"
                                      style={{
                                        textAlign: "center",
                                        fontFamily: "AeonikTRIAL-Regular",
                                        fontSize: 48
                                      }}
                                    >
                                      <span data-slate-node="text">
                                        <span
                                          data-slate-leaf="true"
                                          className="sc-5fc0b980-0 fSzefS"
                                          style={{ color: "inherit" }}
                                        >
                                          <span data-slate-string="true">
                                            123{" "}
                                          </span>
                                        </span>
                                      </span>
                                      <span data-slate-node="text">
                                        <span
                                          data-slate-leaf="true"
                                          className="sc-5fc0b980-0 fSzefS"
                                          style={{ color: "inherit" }}
                                        >
                                          <em style={{ color: "inherit" }}>
                                            <span data-slate-string="true">
                                              new Line
                                            </span>
                                          </em>
                                        </span>
                                      </span>
                                    </h2>
                                  </div>
                                </div>
                                <div className="sc-79126d1b-0 iJijkg">
                                  <div
                                    role="button"
                                    tabIndex={0}
                                    aria-disabled="false"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sc-51ef7276-0 hFuWPD"
                                  >
                                    <div
                                      className="sc-76ec0e49-3 gRhSJE"
                                      style={{ width: "auto" }}
                                    >
                                      <div className="sc-9284fa03-0 eLvnec">
                                        <button
                                          id="image-container"
                                          className="sc-489f2077-1 dZXWLx sc-9284fa03-1 fbaggX"
                                        >
                                          <svg
                                            width={22}
                                            height={21}
                                            viewBox="0 0 22 21"
                                            fill="none"
                                            className="sc-9284fa03-2 jkmTCG"
                                          >
                                            <path
                                              d="M17.984 3a3.25 3.25 0 0 1 3.25 3.25v11.5a3.25 3.25 0 0 1-3.25 3.25h-11.5a3.25 3.25 0 0 1-3.25-3.25v-6.248c.474.198.977.34 1.5.422v5.826c0 .208.036.408.103.594l5.823-5.701a2.25 2.25 0 0 1 3.02-.116l.128.116 5.822 5.702c.067-.186.104-.386.104-.595V6.25a1.75 1.75 0 0 0-1.75-1.75h-5.827a6.457 6.457 0 0 0-.421-1.5h6.248Zm-6.191 10.644-.084.07-5.807 5.687c.182.064.378.099.582.099h11.5c.203 0 .399-.035.58-.099l-5.805-5.686a.75.75 0 0 0-.966-.071ZM15.486 6.5a2.252 2.252 0 1 1 0 4.504 2.252 2.252 0 0 1 0-4.504ZM5.734 0a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm9.752 8a.752.752 0 1 0 0 1.504.752.752 0 0 0 0-1.504ZM5.734 2l-.09.007a.5.5 0 0 0-.402.402l-.008.09V5H2.732l-.09.008a.5.5 0 0 0-.402.402l-.008.09.008.09a.5.5 0 0 0 .402.402l.09.008h2.503v2.503l.008.09a.5.5 0 0 0 .402.402l.09.008.09-.008a.5.5 0 0 0 .402-.402l.008-.09V6h2.503l.09-.008a.5.5 0 0 0 .402-.402l.008-.09-.008-.09a.5.5 0 0 0-.402-.402L8.738 5H6.234V2.5l-.008-.09a.5.5 0 0 0-.402-.403L5.734 2Z"
                                              fill="currentColor"
                                            />
                                          </svg>
                                        </button>
                                        <div className="sc-9b97bd27-0 dtODpt" />
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    role="button"
                                    tabIndex={0}
                                    aria-disabled="false"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sc-51ef7276-0 hFuWPD"
                                  >
                                    <div
                                      className="sc-76ec0e49-3 gRhSJE"
                                      style={{ width: "auto" }}
                                    >
                                      <div className="sc-9284fa03-0 eLvnec">
                                        <button
                                          id="image-container"
                                          className="sc-489f2077-1 dZXWLx sc-9284fa03-1 fbaggX"
                                        >
                                          <svg
                                            width={22}
                                            height={21}
                                            viewBox="0 0 22 21"
                                            fill="none"
                                            className="sc-9284fa03-2 jkmTCG"
                                          >
                                            <path
                                              d="M17.984 3a3.25 3.25 0 0 1 3.25 3.25v11.5a3.25 3.25 0 0 1-3.25 3.25h-11.5a3.25 3.25 0 0 1-3.25-3.25v-6.248c.474.198.977.34 1.5.422v5.826c0 .208.036.408.103.594l5.823-5.701a2.25 2.25 0 0 1 3.02-.116l.128.116 5.822 5.702c.067-.186.104-.386.104-.595V6.25a1.75 1.75 0 0 0-1.75-1.75h-5.827a6.457 6.457 0 0 0-.421-1.5h6.248Zm-6.191 10.644-.084.07-5.807 5.687c.182.064.378.099.582.099h11.5c.203 0 .399-.035.58-.099l-5.805-5.686a.75.75 0 0 0-.966-.071ZM15.486 6.5a2.252 2.252 0 1 1 0 4.504 2.252 2.252 0 0 1 0-4.504ZM5.734 0a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm9.752 8a.752.752 0 1 0 0 1.504.752.752 0 0 0 0-1.504ZM5.734 2l-.09.007a.5.5 0 0 0-.402.402l-.008.09V5H2.732l-.09.008a.5.5 0 0 0-.402.402l-.008.09.008.09a.5.5 0 0 0 .402.402l.09.008h2.503v2.503l.008.09a.5.5 0 0 0 .402.402l.09.008.09-.008a.5.5 0 0 0 .402-.402l.008-.09V6h2.503l.09-.008a.5.5 0 0 0 .402-.402l.008-.09-.008-.09a.5.5 0 0 0-.402-.402L8.738 5H6.234V2.5l-.008-.09a.5.5 0 0 0-.402-.403L5.734 2Z"
                                              fill="currentColor"
                                            />
                                          </svg>
                                        </button>
                                        <div className="sc-9b97bd27-0 dtODpt" />
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    role="button"
                                    tabIndex={0}
                                    aria-disabled="false"
                                    aria-roledescription="sortable"
                                    aria-describedby="DndDescribedBy-0"
                                    className="sc-51ef7276-0 hFuWPD"
                                  >
                                    <div
                                      className="sc-76ec0e49-3 gRhSJE"
                                      style={{ width: "auto" }}
                                    >
                                      <div className="sc-9284fa03-0 eLvnec">
                                        <button
                                          id="image-container"
                                          className="sc-489f2077-1 dZXWLx sc-9284fa03-1 fbaggX"
                                        >
                                          <svg
                                            width={22}
                                            height={21}
                                            viewBox="0 0 22 21"
                                            fill="none"
                                            className="sc-9284fa03-2 jkmTCG"
                                          >
                                            <path
                                              d="M17.984 3a3.25 3.25 0 0 1 3.25 3.25v11.5a3.25 3.25 0 0 1-3.25 3.25h-11.5a3.25 3.25 0 0 1-3.25-3.25v-6.248c.474.198.977.34 1.5.422v5.826c0 .208.036.408.103.594l5.823-5.701a2.25 2.25 0 0 1 3.02-.116l.128.116 5.822 5.702c.067-.186.104-.386.104-.595V6.25a1.75 1.75 0 0 0-1.75-1.75h-5.827a6.457 6.457 0 0 0-.421-1.5h6.248Zm-6.191 10.644-.084.07-5.807 5.687c.182.064.378.099.582.099h11.5c.203 0 .399-.035.58-.099l-5.805-5.686a.75.75 0 0 0-.966-.071ZM15.486 6.5a2.252 2.252 0 1 1 0 4.504 2.252 2.252 0 0 1 0-4.504ZM5.734 0a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm9.752 8a.752.752 0 1 0 0 1.504.752.752 0 0 0 0-1.504ZM5.734 2l-.09.007a.5.5 0 0 0-.402.402l-.008.09V5H2.732l-.09.008a.5.5 0 0 0-.402.402l-.008.09.008.09a.5.5 0 0 0 .402.402l.09.008h2.503v2.503l.008.09a.5.5 0 0 0 .402.402l.09.008.09-.008a.5.5 0 0 0 .402-.402l.008-.09V6h2.503l.09-.008a.5.5 0 0 0 .402-.402l.008-.09-.008-.09a.5.5 0 0 0-.402-.402L8.738 5H6.234V2.5l-.008-.09a.5.5 0 0 0-.402-.403L5.734 2Z"
                                              fill="currentColor"
                                            />
                                          </svg>
                                        </button>
                                        <div className="sc-9b97bd27-0 dtODpt" />
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    id="DndDescribedBy-0"
                                    style={{ display: "none" }}
                                  >
                                    To pick up a draggable item, press the space
                                    bar. While dragging, use the arrow keys to
                                    move the item. Press space again to drop the
                                    item in its new position, or press escape to
                                    cancel.
                                  </div>
                                  <div
                                    id="DndLiveRegion-0"
                                    role="status"
                                    aria-live="assertive"
                                    aria-atomic="true"
                                    style={{
                                      position: "fixed",
                                      width: 1,
                                      height: 1,
                                      margin: "-1px",
                                      border: 0,
                                      padding: 0,
                                      overflow: "hidden",
                                      clip: "rect(0px, 0px, 0px, 0px)",
                                      clipPath: "inset(100%)",
                                      whiteSpace: "nowrap"
                                    }}
                                  />
                                </div>
                                <div style={{ width: 1, height: 1 }} />
                              </div>
                            </div>
                          </div>
                        </cord-presence-observer>
                        <cord-presence-observer
                          buffer-events="false"
                          location='{"section":"livepod","component":"nextsteps-nextsteps-66aa63a6-1676-43b8-b3ff-5e4f8e13edb2"}'
                        >
                          <div
                            id="nextsteps-66aa63a6-1676-43b8-b3ff-5e4f8e13edb2"
                            className="sc-b8209179-0 sc-38009e75-0 dVWbqJ"
                            style={{ marginBottom: "2rem" }}
                          >
                            <div className="sc-b8209179-1 sc-38009e75-1 jcukRr">
                              <div className="sc-746af168-0 ksmBEe widget-container">
                                <div style={{ width: 1, height: 1 }} />
                                <div className="sc-9b97bd27-0 iFgbpX">
                                  <div
                                    id="next-steps-title"
                                    className="sc-ce447d5d-1 jtwkdv sc-79126d1b-2 vyTsQ"
                                  >
                                    <div
                                      spellCheck="true"
                                      className="sc-ce447d5d-2 fsmvhR"
                                      data-slate-editor="true"
                                      data-slate-node="value"
                                      contentEditable="false"
                                      zindex={-1}
                                      style={{
                                        position: "relative",
                                        outline: "none",
                                        whiteSpace: "pre-wrap",
                                        overflowWrap: "break-word"
                                      }}
                                    >
                                      <h2
                                        data-slate-node="element"
                                        style={{
                                          textAlign: "center",
                                          fontFamily: "AeonikTRIAL-Regular",
                                          fontSize: 48
                                        }}
                                      >
                                        <span data-slate-node="text">
                                          <span
                                            data-slate-leaf="true"
                                            className="sc-5fc0b980-0 fSzefS"
                                            style={{ color: "inherit" }}
                                          >
                                            <span data-slate-string="true">
                                              {" "}
                                              Sam@sendtrumpet.com,
                                            </span>
                                          </span>
                                        </span>
                                      </h2>
                                    </div>
                                  </div>
                                  <div className="sc-51ef7276-0 brXHPA">
                                    <div className="sc-efaa2eb5-0 ijtvQ">
                                      <div className="sc-51ef7276-0 cHDUDt" />
                                      <div className="sc-efaa2eb5-1 kDihnG">
                                        <ul
                                          style={{
                                            listStyle: "none",
                                            padding: 0,
                                            margin: 0
                                          }}
                                        >
                                          <li>
                                            <div
                                              className="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiAccordion-root MuiAccordion-rounded Mui-expanded css-8rxlsu"
                                              style={{ borderRadius: 9 }}
                                            >
                                              <div
                                                className="MuiButtonBase-root MuiAccordionSummary-root Mui-expanded css-98ak30"
                                                tabIndex={0}
                                                role="button"
                                                aria-expanded="true"
                                                aria-controls="panel-0-header"
                                                id="panel-0-header"
                                              >
                                                <div className="MuiAccordionSummary-content Mui-expanded css-1n11r91">
                                                  <div
                                                    width="100%"
                                                    className="sc-f87886bd-0 dQROvr"
                                                  >
                                                    <div
                                                      width="67%"
                                                      className="sc-51ef7276-0 gEIgRw"
                                                    />
                                                    <div className="sc-f87886bd-0 dtIOZI">
                                                      <div
                                                        className="sc-51ef7276-0 bzsoOI"
                                                        style={{
                                                          fontSize: 12,
                                                          textTransform:
                                                            "uppercase",
                                                          fontWeight: 600,
                                                          color:
                                                            "rgb(255, 255, 255)",
                                                          letterSpacing: 1,
                                                          width: "max-content"
                                                        }}
                                                      >
                                                        NOT STARTED
                                                      </div>
                                                      <span
                                                        style={{
                                                          color:
                                                            "rgb(24, 23, 28)",
                                                          fontSize: 14,
                                                          textTransform:
                                                            "uppercase",
                                                          fontWeight: 600,
                                                          padding: "0px 16px",
                                                          width: "max-content"
                                                        }}
                                                      >
                                                        0/1
                                                      </span>
                                                    </div>
                                                  </div>
                                                  <canvas
                                                    style={{
                                                      position: "fixed",
                                                      pointerEvents: "none",
                                                      width: "100%",
                                                      height: "100%",
                                                      top: 0,
                                                      left: 0
                                                    }}
                                                  />
                                                </div>
                                                <div className="MuiAccordionSummary-expandIconWrapper Mui-expanded css-1fx8m19">
                                                  <svg
                                                    width={24}
                                                    height={24}
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    className="summary-chevron"
                                                  >
                                                    <path
                                                      d="M4.29289 8.29289C4.68342 7.90237 5.31658 7.90237 5.70711 8.29289L12 14.5858L18.2929 8.29289C18.6834 7.90237 19.3166 7.90237 19.7071 8.29289C20.0976 8.68342 20.0976 9.31658 19.7071 9.70711L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L4.29289 9.70711C3.90237 9.31658 3.90237 8.68342 4.29289 8.29289Z"
                                                      fill="currentColor"
                                                    />
                                                  </svg>
                                                </div>
                                              </div>
                                              <div
                                                className="MuiCollapse-root MuiCollapse-vertical MuiCollapse-entered css-c4sutr"
                                                style={{ minHeight: 0 }}
                                              >
                                                <div className="MuiCollapse-wrapper MuiCollapse-vertical css-hboir5">
                                                  <div className="MuiCollapse-wrapperInner MuiCollapse-vertical css-8atqhb">
                                                    <div
                                                      aria-labelledby="panel-0-header"
                                                      id="panel-0-header"
                                                      role="region"
                                                      className="MuiAccordion-region"
                                                    >
                                                      <div className="MuiAccordionDetails-root css-1fnliye">
                                                        <div>
                                                          <div
                                                            data-rbd-droppable-id="next-steps"
                                                            data-rbd-droppable-context-id={
                                                              1
                                                            }
                                                            style={{
                                                              background:
                                                                "white",
                                                              padding: 8,
                                                              borderRadius: 8
                                                            }}
                                                          >
                                                            <div
                                                              data-rbd-draggable-context-id={
                                                                1
                                                              }
                                                              data-rbd-draggable-id={
                                                                1
                                                              }
                                                              className="sc-baf59017-0 fbuMZl"
                                                            >
                                                              <div className="sc-563717fe-0 kLgYFW">
                                                                <div className="sc-f87886bd-0 dSPIim">
                                                                  <div
                                                                    width="96%"
                                                                    className="sc-f87886bd-0 dZpBWQ"
                                                                  >
                                                                    <div className="sc-a693beab-0 hfhfdU">
                                                                      <div className="sc-a693beab-1 ekSGsj">
                                                                        <input
                                                                          type="checkbox"
                                                                          id="cbx-0-0-c3182c1d-c761-44d5-a330-a5c60c1104d1"
                                                                          name="cbx-0-0-c3182c1d-c761-44d5-a330-a5c60c1104d1"
                                                                          className="sc-a693beab-5 gbBSKT"
                                                                        />
                                                                        <label
                                                                          htmlFor="cbx-0-0-c3182c1d-c761-44d5-a330-a5c60c1104d1"
                                                                          className="sc-6d1fb138-4 sc-a693beab-4 caemh nLBas"
                                                                        >
                                                                          <div className="sc-a693beab-3 ifAIPp">
                                                                            <svg
                                                                              xmlns="http://www.w3.org/2000/svg"
                                                                              width={
                                                                                24
                                                                              }
                                                                              height={
                                                                                24
                                                                              }
                                                                              viewBox="0 0 24 24"
                                                                              fill="none"
                                                                              stroke="currentColor"
                                                                              strokeWidth={
                                                                                2
                                                                              }
                                                                              strokeLinecap="round"
                                                                              strokeLinejoin="round"
                                                                              className="sc-a693beab-2 iziZdE"
                                                                            >
                                                                              <polyline points="20 6 9 17 4 12" />
                                                                            </svg>
                                                                          </div>
                                                                        </label>
                                                                      </div>
                                                                    </div>
                                                                    <div
                                                                      width="95%"
                                                                      className="sc-9b97bd27-0 bRozlx"
                                                                    >
                                                                      <div
                                                                        className="sc-f87886bd-0 jJrbPs step-vstack"
                                                                        width="100%"
                                                                      >
                                                                        <div
                                                                          width="86%"
                                                                          className="sc-9b97bd27-0 knJgKq"
                                                                          style={{
                                                                            rowGap: 0
                                                                          }}
                                                                        />
                                                                        <div
                                                                          className="sc-f87886bd-0 fqLPRr step-action-buttons"
                                                                          width="5%"
                                                                        />
                                                                      </div>
                                                                      <div
                                                                        className="sc-f87886bd-0 FapiV footer-actions"
                                                                        display="flex"
                                                                      >
                                                                        <div className="sc-f87886bd-0 sc-5afa2cd2-1 hqjueY jYNIeM">
                                                                          <div />
                                                                          <div />
                                                                        </div>
                                                                        <div className="sc-51ef7276-0 sc-5afa2cd2-0 hFuWPD eyyrSx">
                                                                          <div className="sc-51ef7276-0 cEbXiw">
                                                                            <div
                                                                              aria-label=""
                                                                              className=""
                                                                              style={{
                                                                                display:
                                                                                  "flex"
                                                                              }}
                                                                            >
                                                                              <div
                                                                                aria-haspopup="true"
                                                                                role="button"
                                                                                className="sc-51ef7276-0 hFuWPD context-menu-button"
                                                                              >
                                                                                <div
                                                                                  display="inline-flex"
                                                                                  className="sc-51ef7276-0 hbccAX"
                                                                                  style={{
                                                                                    cursor:
                                                                                      "pointer"
                                                                                  }}
                                                                                >
                                                                                  <span className="footer-text">
                                                                                    <svg
                                                                                      width={
                                                                                        17
                                                                                      }
                                                                                      height={
                                                                                        17
                                                                                      }
                                                                                      fill="none"
                                                                                      viewBox="0 0 24 24"
                                                                                      color="#413CC3"
                                                                                      xmlns="http://www.w3.org/2000/svg"
                                                                                      version="1.1"
                                                                                    >
                                                                                      <path
                                                                                        d="M11.772 3.743a6 6 0 0 1 8.66 8.302l-.19.197-8.8 8.798-.036.03a3.723 3.723 0 0 1-5.489-4.973.764.764 0 0 1 .085-.13l.054-.06.086-.088.142-.148.002.003 7.436-7.454a.75.75 0 0 1 .977-.074l.084.073a.75.75 0 0 1 .074.976l-.073.084-7.594 7.613a2.23 2.23 0 0 0 3.174 3.106l8.832-8.83A4.502 4.502 0 0 0 13 4.644l-.168.16-.013.014-9.536 9.536a.75.75 0 0 1-1.133-.977l.072-.084 9.549-9.55h.002Z"
                                                                                        fill="currentColor"
                                                                                      />
                                                                                    </svg>
                                                                                  </span>
                                                                                  <div
                                                                                    className="footer-text"
                                                                                    style={{
                                                                                      paddingTop: 0
                                                                                    }}
                                                                                  >
                                                                                    Files
                                                                                    (0)
                                                                                  </div>
                                                                                </div>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div style={{ width: 1, height: 1 }} />
                              </div>
                            </div>
                          </div>
                        </cord-presence-observer>
                        <cord-presence-observer
                          buffer-events="false"
                          location='{"section":"livepod","component":"proposals-proposals-cbea6e81-7f74-445a-be79-0d10b446a114"}'
                        >
                          <div
                            id="proposals-cbea6e81-7f74-445a-be79-0d10b446a114"
                            className="sc-b8209179-0 sc-38009e75-0 cVUigE"
                            style={{ marginBottom: "2rem" }}
                          >
                            <div className="sc-b8209179-1 sc-38009e75-1 jcukRr">
                              <div className="sc-746af168-0 iBbBdY widget-container">
                                <div style={{ width: 1, height: 1 }} />
                                <div
                                  width="100%"
                                  className="sc-9b97bd27-0 hqpmmI"
                                >
                                  <div className="sc-8012e1eb-1 jdEvPe">
                                    <div className="sc-51ef7276-0 hFuWPD">
                                      <a
                                        download="Google Deal - Proposal.pdf"
                                        href="blob:https://trumpet.app/9215ef6f-ddae-44dd-bab5-e4e9c8d22977"
                                        style={{ textDecoration: "none" }}
                                      >
                                        <button
                                          role="button"
                                          className="sc-775e4232-2 bKMfgL"
                                        >
                                          <span className="sc-775e4232-1 llMiwm">
                                            Download
                                          </span>
                                          <div className="sc-775e4232-4 iDlDCY">
                                            <svg
                                              width={24}
                                              height={24}
                                              viewBox="0 0 24 24"
                                              fill="none"
                                            >
                                              <path
                                                d="M5.25 20.5H18.748C18.9379 20.5003 19.1207 20.5727 19.2593 20.7025C19.398 20.8323 19.4822 21.0099 19.4951 21.1994C19.5079 21.3889 19.4483 21.5762 19.3284 21.7235C19.2085 21.8708 19.0372 21.9671 18.849 21.993L18.748 22H5.25C5.05862 22.0019 4.87374 21.9307 4.73322 21.8007C4.59269 21.6708 4.50715 21.4921 4.49411 21.3011C4.48108 21.1102 4.54153 20.9215 4.66309 20.7737C4.78466 20.6258 4.95813 20.5301 5.148 20.506L5.25 20.5ZM11.883 2.002L12 1.995C12.2449 1.99503 12.4813 2.08495 12.6644 2.24771C12.8474 2.41047 12.9643 2.63474 12.993 2.878L13 2.99499V15.585L16.294 12.292C16.4662 12.1198 16.6953 12.0164 16.9383 12.0011C17.1813 11.9858 17.4216 12.0597 17.614 12.209L17.708 12.293C17.8802 12.4652 17.9836 12.6943 17.9989 12.9373C18.0142 13.1803 17.9403 13.4206 17.791 13.613L17.708 13.707L12.711 18.703C12.5389 18.8753 12.3099 18.9789 12.0669 18.9944C11.8238 19.0099 11.5835 18.9361 11.391 18.787L11.297 18.704L6.293 13.707C6.11174 13.5275 6.00597 13.2854 5.99732 13.0304C5.98866 12.7755 6.0778 12.5268 6.24646 12.3354C6.41513 12.144 6.65058 12.0243 6.90462 12.0008C7.15866 11.9773 7.41208 12.0518 7.613 12.209L7.707 12.292L11 15.58V2.99499C11 2.75006 11.09 2.51366 11.2527 2.33062C11.4155 2.14759 11.6397 2.03065 11.883 2.002Z"
                                                fill="currentColor"
                                              />
                                            </svg>
                                          </div>
                                        </button>
                                      </a>
                                    </div>
                                  </div>
                                  <div
                                    width="100%"
                                    height="100%"
                                    className="sc-51ef7276-0 cebGAG"
                                    style={{
                                      boxShadow:
                                        "rgba(24, 23, 28, 0.12) 0px 8px 22px -6px, rgba(24, 23, 28, 0.12) 0px 14px 64px -4px",
                                      borderRadius: 10
                                    }}
                                  >
                                    <div
                                      width="100%"
                                      height="100%"
                                      className="sc-9b97bd27-0 gajgGG"
                                    >
                                      <div className="sc-51ef7276-0 hFuWPD">
                                        <div className="sc-8012e1eb-2 fbPsXa">
                                          <div className="sc-610dc7ee-0 jMtEdH">
                                            <div
                                              className="sc-51ef7276-0 bbOElH"
                                              style={{
                                                wordBreak: "break-word"
                                              }}
                                            >
                                              <div
                                                id="header-title-text"
                                                className="sc-ce447d5d-1 jtwkdv sc-610dc7ee-1 fcAEdB"
                                              >
                                                <div
                                                  spellCheck="true"
                                                  className="sc-ce447d5d-2 fsmvhR"
                                                  data-slate-editor="true"
                                                  data-slate-node="value"
                                                  contentEditable="false"
                                                  zindex={-1}
                                                  style={{
                                                    position: "relative",
                                                    outline: "none",
                                                    whiteSpace: "pre-wrap",
                                                    overflowWrap: "break-word"
                                                  }}
                                                >
                                                  <h3
                                                    data-slate-node="element"
                                                    style={{
                                                      fontFamily: "Roboto",
                                                      fontSize: 32
                                                    }}
                                                  >
                                                    <span data-slate-node="text">
                                                      <span
                                                        data-slate-leaf="true"
                                                        className="sc-5fc0b980-0 fSzefS"
                                                        style={{
                                                          color: "inherit"
                                                        }}
                                                      >
                                                        <strong
                                                          style={{
                                                            color: "inherit"
                                                          }}
                                                        >
                                                          <span data-slate-string="true">
                                                            Header section
                                                          </span>
                                                        </strong>
                                                      </span>
                                                    </span>
                                                  </h3>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="sc-51ef7276-0 fzzkJB">
                                              <div className="sc-f87886bd-0 hqjueY">
                                                <div className="sc-51ef7276-0 gdpQai">
                                                  <div
                                                    className="sc-76ec0e49-3 gRhSJE sc-489f2077-5 cfigiV"
                                                    style={{ width: "auto" }}
                                                  >
                                                    <button
                                                      id="image-container"
                                                      className="sc-489f2077-1 kjUYFa sc-610dc7ee-3 kFyRhh"
                                                    >
                                                      <img
                                                        src="https://asset.brandfetch.io/id6O2oGzv-/idvNIQR3p7.svg"
                                                        alt=""
                                                        id="image-element"
                                                        className="sc-489f2077-0 bvQkuA"
                                                        style={{
                                                          cursor: "inherit"
                                                        }}
                                                      />
                                                    </button>
                                                  </div>
                                                </div>
                                                <div className="sc-51ef7276-0 hFuWPD">
                                                  <div
                                                    className="sc-76ec0e49-3 gRhSJE sc-489f2077-5 cfigiV"
                                                    style={{ width: "auto" }}
                                                  >
                                                    <button
                                                      id="image-container"
                                                      className="sc-489f2077-1 dZXWLx sc-610dc7ee-3 kFzLPA"
                                                    >
                                                      <svg
                                                        width={22}
                                                        height={21}
                                                        viewBox="0 0 22 21"
                                                        fill="none"
                                                        className="sc-610dc7ee-4 kGQNYi"
                                                      >
                                                        <path
                                                          d="M17.984 3a3.25 3.25 0 0 1 3.25 3.25v11.5a3.25 3.25 0 0 1-3.25 3.25h-11.5a3.25 3.25 0 0 1-3.25-3.25v-6.248c.474.198.977.34 1.5.422v5.826c0 .208.036.408.103.594l5.823-5.701a2.25 2.25 0 0 1 3.02-.116l.128.116 5.822 5.702c.067-.186.104-.386.104-.595V6.25a1.75 1.75 0 0 0-1.75-1.75h-5.827a6.457 6.457 0 0 0-.421-1.5h6.248Zm-6.191 10.644-.084.07-5.807 5.687c.182.064.378.099.582.099h11.5c.203 0 .399-.035.58-.099l-5.805-5.686a.75.75 0 0 0-.966-.071ZM15.486 6.5a2.252 2.252 0 1 1 0 4.504 2.252 2.252 0 0 1 0-4.504ZM5.734 0a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm9.752 8a.752.752 0 1 0 0 1.504.752.752 0 0 0 0-1.504ZM5.734 2l-.09.007a.5.5 0 0 0-.402.402l-.008.09V5H2.732l-.09.008a.5.5 0 0 0-.402.402l-.008.09.008.09a.5.5 0 0 0 .402.402l.09.008h2.503v2.503l.008.09a.5.5 0 0 0 .402.402l.09.008.09-.008a.5.5 0 0 0 .402-.402l.008-.09V6h2.503l.09-.008a.5.5 0 0 0 .402-.402l.008-.09-.008-.09a.5.5 0 0 0-.402-.402L8.738 5H6.234V2.5l-.008-.09a.5.5 0 0 0-.402-.403L5.734 2Z"
                                                          fill="currentColor"
                                                        />
                                                      </svg>
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        display="flex"
                                        width="100%"
                                        className="sc-f87886bd-0 cZrKfj"
                                      >
                                        <div
                                          width="100%"
                                          height="inherit"
                                          className="sc-51ef7276-0 hZRPfL"
                                        >
                                          <div className="sc-8012e1eb-2 fbPsXa">
                                            <div className="sc-9b97bd27-0 eqCCIw">
                                              <div className="sc-51ef7276-0 fpUbFa">
                                                <div
                                                  id="proposalInfo-title-text"
                                                  className="sc-ce447d5d-1 jtwkdv sc-886f27c5-0 bhOrGf"
                                                >
                                                  <div
                                                    spellCheck="true"
                                                    className="sc-ce447d5d-2 fsmvhR"
                                                    data-slate-editor="true"
                                                    data-slate-node="value"
                                                    contentEditable="false"
                                                    zindex={-1}
                                                    style={{
                                                      position: "relative",
                                                      outline: "none",
                                                      whiteSpace: "pre-wrap",
                                                      overflowWrap: "break-word"
                                                    }}
                                                  >
                                                    <h3
                                                      data-slate-node="element"
                                                      style={{
                                                        fontFamily: "Roboto",
                                                        fontSize: 32
                                                      }}
                                                    >
                                                      <span data-slate-node="text">
                                                        <span
                                                          data-slate-leaf="true"
                                                          className="sc-5fc0b980-0 fSzefS"
                                                          style={{
                                                            color: "inherit"
                                                          }}
                                                        >
                                                          <strong
                                                            style={{
                                                              color: "inherit"
                                                            }}
                                                          >
                                                            <span data-slate-string="true">
                                                              Proposal/Quote
                                                              Info
                                                            </span>
                                                          </strong>
                                                        </span>
                                                      </span>
                                                    </h3>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                display="none"
                                                className="sc-51ef7276-0 dHqVYE"
                                              >
                                                <div
                                                  width="100%"
                                                  className="sc-f87886bd-0 dTYNOn"
                                                >
                                                  <div
                                                    id="proposalInfo-quote-label"
                                                    className="sc-ce447d5d-1 jtwkdv sc-886f27c5-1 fhrHEz"
                                                    style={{
                                                      width: "auto",
                                                      marginRight: 5
                                                    }}
                                                  >
                                                    <div
                                                      spellCheck="true"
                                                      className="sc-ce447d5d-2 fsmvhR"
                                                      data-slate-editor="true"
                                                      data-slate-node="value"
                                                      contentEditable="false"
                                                      zindex={-1}
                                                      style={{
                                                        position: "relative",
                                                        outline: "none",
                                                        whiteSpace: "pre-wrap",
                                                        overflowWrap:
                                                          "break-word"
                                                      }}
                                                    >
                                                      <p
                                                        data-slate-node="element"
                                                        style={{
                                                          margin: 0,
                                                          fontFamily:
                                                            "AeonikTRIAL-Regular",
                                                          fontSize: 16
                                                        }}
                                                      >
                                                        <span data-slate-node="text">
                                                          <span
                                                            data-slate-leaf="true"
                                                            className="sc-5fc0b980-0 fSzefS"
                                                            style={{
                                                              color: "inherit"
                                                            }}
                                                          >
                                                            <strong
                                                              style={{
                                                                color: "inherit"
                                                              }}
                                                            >
                                                              <span data-slate-string="true">
                                                                Quote Number:
                                                              </span>
                                                            </strong>
                                                          </span>
                                                        </span>
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                display="flex"
                                                className="sc-51ef7276-0 bFYRJF"
                                              >
                                                <div className="sc-f87886bd-0 gYUhSU">
                                                  <div className="sc-f87886bd-0 gYUhSU">
                                                    <div
                                                      id="proposalInfo-createdDate-label"
                                                      className="sc-ce447d5d-1 jtwkdv sc-886f27c5-1 fhrHEz"
                                                      style={{
                                                        width: "max-content",
                                                        marginRight: 5
                                                      }}
                                                    >
                                                      <div
                                                        spellCheck="true"
                                                        className="sc-ce447d5d-2 fsmvhR"
                                                        data-slate-editor="true"
                                                        data-slate-node="value"
                                                        contentEditable="false"
                                                        zindex={-1}
                                                        style={{
                                                          position: "relative",
                                                          outline: "none",
                                                          whiteSpace:
                                                            "pre-wrap",
                                                          overflowWrap:
                                                            "break-word"
                                                        }}
                                                      >
                                                        <p
                                                          data-slate-node="element"
                                                          style={{
                                                            margin: 0,
                                                            fontFamily:
                                                              "AeonikTRIAL-Regular",
                                                            fontSize: 16
                                                          }}
                                                        >
                                                          <span data-slate-node="text">
                                                            <span
                                                              data-slate-leaf="true"
                                                              className="sc-5fc0b980-0 fSzefS"
                                                              style={{
                                                                color: "inherit"
                                                              }}
                                                            >
                                                              <strong
                                                                style={{
                                                                  color:
                                                                    "inherit"
                                                                }}
                                                              >
                                                                <span data-slate-string="true">
                                                                  Created Date:
                                                                </span>
                                                              </strong>
                                                            </span>
                                                          </span>
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div
                                                    width="100%"
                                                    className="sc-f87886bd-0 dTYNOn"
                                                  >
                                                    <div
                                                      className="sc-80a80b8d-0 ixfKs"
                                                      style={{
                                                        fontFamily:
                                                          "AeonikTRIAL-Regular"
                                                      }}
                                                    >
                                                      <div className="react-datepicker-wrapper">
                                                        <div className="react-datepicker__input-container">
                                                          <input
                                                            type="text"
                                                            placeholder="00/00/0000"
                                                            disabled=""
                                                            className=""
                                                            defaultValue="11/12/2023"
                                                          />
                                                          <button
                                                            type="button"
                                                            className="react-datepicker__close-icon"
                                                            aria-label="Close"
                                                            title="clear"
                                                            tabIndex={-1}
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                display="none"
                                                className="sc-51ef7276-0 dzunQi"
                                              >
                                                <div
                                                  width="100%"
                                                  className="sc-f87886bd-0 dTYNOn"
                                                >
                                                  <div className="sc-f87886bd-0 gYUhSU">
                                                    <div
                                                      id="proposalInfo-expiryDateLabel-label"
                                                      className="sc-ce447d5d-1 jtwkdv sc-886f27c5-1 fhrHEz"
                                                      style={{
                                                        width: "max-content",
                                                        marginRight: 5
                                                      }}
                                                    >
                                                      <div
                                                        spellCheck="true"
                                                        className="sc-ce447d5d-2 fsmvhR"
                                                        data-slate-editor="true"
                                                        data-slate-node="value"
                                                        contentEditable="false"
                                                        zindex={-1}
                                                        style={{
                                                          position: "relative",
                                                          outline: "none",
                                                          whiteSpace:
                                                            "pre-wrap",
                                                          overflowWrap:
                                                            "break-word"
                                                        }}
                                                      >
                                                        <p
                                                          data-slate-node="element"
                                                          style={{
                                                            margin: 0,
                                                            fontFamily:
                                                              "AeonikTRIAL-Regular",
                                                            fontSize: 16
                                                          }}
                                                        >
                                                          <span data-slate-node="text">
                                                            <span
                                                              data-slate-leaf="true"
                                                              className="sc-5fc0b980-0 fSzefS"
                                                              style={{
                                                                color: "inherit"
                                                              }}
                                                            >
                                                              <strong
                                                                style={{
                                                                  color:
                                                                    "inherit"
                                                                }}
                                                              >
                                                                <span data-slate-string="true">
                                                                  Expiry Date:
                                                                </span>
                                                              </strong>
                                                            </span>
                                                          </span>
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div
                                                    width="100%"
                                                    className="sc-f87886bd-0 dTYNOn"
                                                  >
                                                    <div
                                                      className="sc-80a80b8d-0 ixfKs"
                                                      style={{
                                                        fontFamily:
                                                          "AeonikTRIAL-Regular"
                                                      }}
                                                    >
                                                      <div className="react-datepicker-wrapper">
                                                        <div className="react-datepicker__input-container">
                                                          <input
                                                            type="text"
                                                            placeholder="00/00/0000"
                                                            disabled=""
                                                            className=""
                                                            defaultValue=""
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        display="flex"
                                        width="100%"
                                        className="sc-f87886bd-0 dziZNW"
                                      >
                                        <div
                                          width="100%"
                                          className="sc-51ef7276-0 elqdpM"
                                        >
                                          <div className="sc-8012e1eb-2 fbPsXa">
                                            <div className="sc-9b97bd27-0 eqCCIw">
                                              <div
                                                display="flex"
                                                className="sc-51ef7276-0 wauCG"
                                              >
                                                <div
                                                  id="preparedFor-title-text"
                                                  className="sc-ce447d5d-1 jtwkdv sc-a327a5f6-0 bjZMxz"
                                                >
                                                  <div
                                                    spellCheck="true"
                                                    className="sc-ce447d5d-2 fsmvhR"
                                                    data-slate-editor="true"
                                                    data-slate-node="value"
                                                    contentEditable="false"
                                                    zindex={-1}
                                                    style={{
                                                      position: "relative",
                                                      outline: "none",
                                                      whiteSpace: "pre-wrap",
                                                      overflowWrap: "break-word"
                                                    }}
                                                  >
                                                    <h3
                                                      data-slate-node="element"
                                                      style={{
                                                        fontFamily: "Roboto",
                                                        fontSize: 32
                                                      }}
                                                    >
                                                      <span data-slate-node="text">
                                                        <span
                                                          data-slate-leaf="true"
                                                          className="sc-5fc0b980-0 fSzefS"
                                                          style={{
                                                            color: "inherit"
                                                          }}
                                                        >
                                                          <strong
                                                            style={{
                                                              color: "inherit"
                                                            }}
                                                          >
                                                            <span data-slate-string="true">
                                                              Prepared For
                                                            </span>
                                                          </strong>
                                                        </span>
                                                      </span>
                                                    </h3>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                display="none"
                                                className="sc-51ef7276-0 dHqVYE"
                                              />
                                              <div
                                                display="none"
                                                className="sc-51ef7276-0 dHqVYE"
                                              />
                                              <div
                                                display="none"
                                                className="sc-51ef7276-0 dHqVYE"
                                              />
                                              <div
                                                display="none"
                                                className="sc-51ef7276-0 dHqVYE"
                                              />
                                              <div
                                                display="none"
                                                className="sc-51ef7276-0 dHqVYE"
                                              />
                                              <div
                                                width="100%"
                                                display="none"
                                                className="sc-f87886bd-0 cvnjES"
                                              >
                                                <div
                                                  width="100%"
                                                  className="sc-51ef7276-0 dUPDze"
                                                />
                                                <div
                                                  width="100%"
                                                  className="sc-51ef7276-0 kViKLe"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          width="100%"
                                          className="sc-51ef7276-0 elqdpM"
                                        >
                                          <div className="sc-8012e1eb-2 fbPsXa">
                                            <div className="sc-9b97bd27-0 eqCCIw">
                                              <div
                                                display="flex"
                                                className="sc-51ef7276-0 wauCG"
                                              >
                                                <div
                                                  id="preparedFor-title-text"
                                                  className="sc-ce447d5d-1 jtwkdv sc-a327a5f6-0 bjZMxz"
                                                >
                                                  <div
                                                    spellCheck="true"
                                                    className="sc-ce447d5d-2 fsmvhR"
                                                    data-slate-editor="true"
                                                    data-slate-node="value"
                                                    contentEditable="false"
                                                    zindex={-1}
                                                    style={{
                                                      position: "relative",
                                                      outline: "none",
                                                      whiteSpace: "pre-wrap",
                                                      overflowWrap: "break-word"
                                                    }}
                                                  >
                                                    <h3
                                                      data-slate-node="element"
                                                      style={{
                                                        fontFamily: "Roboto",
                                                        fontSize: 32
                                                      }}
                                                    >
                                                      <span data-slate-node="text">
                                                        <span
                                                          data-slate-leaf="true"
                                                          className="sc-5fc0b980-0 fSzefS"
                                                          style={{
                                                            color: "inherit"
                                                          }}
                                                        >
                                                          <strong
                                                            style={{
                                                              color: "inherit"
                                                            }}
                                                          >
                                                            <span data-slate-string="true">
                                                              From
                                                            </span>
                                                          </strong>
                                                        </span>
                                                      </span>
                                                    </h3>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                display="none"
                                                className="sc-51ef7276-0 dHqVYE"
                                              />
                                              <div
                                                display="none"
                                                className="sc-51ef7276-0 dHqVYE"
                                              />
                                              <div
                                                display="flex"
                                                className="sc-51ef7276-0 bFYRJF"
                                              >
                                                <div
                                                  id="preparedFor-company-text"
                                                  className="sc-ce447d5d-1 jtwkdv sc-a327a5f6-1 iIMBDD"
                                                >
                                                  <div
                                                    spellCheck="true"
                                                    className="sc-ce447d5d-2 fsmvhR"
                                                    data-slate-editor="true"
                                                    data-slate-node="value"
                                                    contentEditable="false"
                                                    zindex={-1}
                                                    style={{
                                                      position: "relative",
                                                      outline: "none",
                                                      whiteSpace: "pre-wrap",
                                                      overflowWrap: "break-word"
                                                    }}
                                                  >
                                                    <p
                                                      data-slate-node="element"
                                                      style={{
                                                        margin: 0,
                                                        fontFamily:
                                                          "AeonikTRIAL-Regular",
                                                        fontSize: 16
                                                      }}
                                                    >
                                                      <span data-slate-node="text">
                                                        <span
                                                          data-slate-leaf="true"
                                                          className="sc-5fc0b980-0 fSzefS"
                                                          style={{
                                                            color: "inherit"
                                                          }}
                                                        >
                                                          <span data-slate-string="true">
                                                            trumpet
                                                          </span>
                                                        </span>
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                display="none"
                                                className="sc-51ef7276-0 dHqVYE"
                                              />
                                              <div
                                                display="none"
                                                className="sc-51ef7276-0 dHqVYE"
                                              />
                                              <div
                                                width="100%"
                                                display="none"
                                                className="sc-f87886bd-0 cvnjES"
                                              >
                                                <div
                                                  width="100%"
                                                  className="sc-51ef7276-0 dUPDze"
                                                />
                                                <div
                                                  width="100%"
                                                  className="sc-51ef7276-0 kViKLe"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        width="100$"
                                        className="sc-f87886bd-0 gsdjwy"
                                      >
                                        <div
                                          width="100%"
                                          height="inherit"
                                          className="sc-51ef7276-0 hZRPfL"
                                        >
                                          <div className="sc-8012e1eb-2 fbPsXa">
                                            <div className="sc-9b97bd27-0 eqCCIw">
                                              <div className="sc-51ef7276-0 fpUbFa">
                                                <div
                                                  id="proposalInfo-title-text"
                                                  className="sc-ce447d5d-1 jtwkdv sc-886f27c5-0 bhOrGf"
                                                >
                                                  <div
                                                    spellCheck="true"
                                                    className="sc-ce447d5d-2 fsmvhR"
                                                    data-slate-editor="true"
                                                    data-slate-node="value"
                                                    contentEditable="false"
                                                    zindex={-1}
                                                    style={{
                                                      position: "relative",
                                                      outline: "none",
                                                      whiteSpace: "pre-wrap",
                                                      overflowWrap: "break-word"
                                                    }}
                                                  >
                                                    <h3
                                                      data-slate-node="element"
                                                      style={{
                                                        fontFamily: "Roboto",
                                                        fontSize: 32
                                                      }}
                                                    >
                                                      <span data-slate-node="text">
                                                        <span
                                                          data-slate-leaf="true"
                                                          className="sc-5fc0b980-0 fSzefS"
                                                          style={{
                                                            color: "inherit"
                                                          }}
                                                        >
                                                          <strong
                                                            style={{
                                                              color: "inherit"
                                                            }}
                                                          >
                                                            <span data-slate-string="true">
                                                              Sales Comments
                                                            </span>
                                                          </strong>
                                                        </span>
                                                      </span>
                                                    </h3>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                display="none"
                                                className="sc-51ef7276-0 dzunQi"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        width="100$"
                                        className="sc-f87886bd-0 gsdjwy"
                                      >
                                        <div
                                          width="100%"
                                          height="inherit"
                                          className="sc-51ef7276-0 hZRPfL"
                                        >
                                          <div className="sc-8012e1eb-2 fbPsXa">
                                            <div className="sc-9b97bd27-0 eqCCIw">
                                              <div className="sc-f87886bd-0 chUksh">
                                                <div
                                                  id="proposalInfo-title-text"
                                                  className="sc-ce447d5d-1 jtwkdv sc-2c63d76-0 eYWPHd"
                                                >
                                                  <div
                                                    spellCheck="true"
                                                    className="sc-ce447d5d-2 fsmvhR"
                                                    data-slate-editor="true"
                                                    data-slate-node="value"
                                                    contentEditable="false"
                                                    zindex={-1}
                                                    style={{
                                                      position: "relative",
                                                      outline: "none",
                                                      whiteSpace: "pre-wrap",
                                                      overflowWrap: "break-word"
                                                    }}
                                                  >
                                                    <h3
                                                      data-slate-node="element"
                                                      style={{
                                                        textAlign: "center",
                                                        fontFamily: "Roboto",
                                                        fontSize: 32
                                                      }}
                                                    >
                                                      <span data-slate-node="text">
                                                        <span
                                                          data-slate-leaf="true"
                                                          className="sc-5fc0b980-0 fSzefS"
                                                          style={{
                                                            color: "inherit"
                                                          }}
                                                        >
                                                          <strong
                                                            style={{
                                                              color: "inherit"
                                                            }}
                                                          >
                                                            <span data-slate-string="true">
                                                              Quote Summary
                                                            </span>
                                                          </strong>
                                                        </span>
                                                      </span>
                                                    </h3>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="sc-2c63d76-2 zfDaJ">
                                                <div className="sc-28414bad-0 ijmzKl">
                                                  <table className="sc-28414bad-1 ka-doQL table">
                                                    <thead>
                                                      <tr className="sc-28414bad-2 iprMrH th">
                                                        <th
                                                          colSpan={1}
                                                          className="sc-28414bad-3 kioleZ"
                                                        >
                                                          <div className="sc-28414bad-4 kTIhNE" />
                                                        </th>
                                                        <th
                                                          colSpan={1}
                                                          className="sc-28414bad-3 kioleZ"
                                                        >
                                                          <div className="sc-28414bad-4 cqhiBs">
                                                            Product
                                                          </div>
                                                        </th>
                                                        <th
                                                          colSpan={1}
                                                          className="sc-28414bad-3 kioleZ"
                                                        >
                                                          <div className="sc-28414bad-4 bDOvAH">
                                                            Price
                                                          </div>
                                                        </th>
                                                        <th
                                                          colSpan={1}
                                                          className="sc-28414bad-3 kioleZ"
                                                        >
                                                          <div className="sc-28414bad-4 bDOvAH">
                                                            Quantity
                                                          </div>
                                                        </th>
                                                        <th
                                                          colSpan={1}
                                                          className="sc-28414bad-3 kioleZ"
                                                        >
                                                          <div className="sc-28414bad-4 bDOvAH">
                                                            Frequency
                                                          </div>
                                                        </th>
                                                        <th
                                                          colSpan={1}
                                                          className="sc-28414bad-3 kioleZ"
                                                        >
                                                          <div className="sc-28414bad-4 bDOvAH">
                                                            Discount
                                                          </div>
                                                        </th>
                                                        <th
                                                          colSpan={1}
                                                          className="sc-28414bad-3 kioleZ"
                                                        >
                                                          <div className="sc-28414bad-4 bDOvAH">
                                                            Total
                                                          </div>
                                                        </th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      <tr className="sc-28414bad-5 eFvJIQ tr">
                                                        <td className="sc-28414bad-6 fYxTuN td">
                                                          <div className="sc-28414bad-7 eWdxak" />
                                                        </td>
                                                        <td className="sc-28414bad-6 fYxTuN td">
                                                          <div className="sc-28414bad-7 gcojaQ">
                                                            <p className="sc-6d1fb138-29 sc-2c63d76-3 gBebUF bVyfAz">
                                                              {" "}
                                                            </p>
                                                          </div>
                                                        </td>
                                                        <td className="sc-28414bad-6 fYxTuN td">
                                                          <div className="sc-28414bad-7 gcojaQ" />
                                                        </td>
                                                        <td className="sc-28414bad-6 fYxTuN td">
                                                          <div className="sc-28414bad-7 gcojaQ">
                                                            <p
                                                              className="sc-6d1fb138-29 sc-2c63d76-3 gBebUF bVyfAz"
                                                              style={{
                                                                width: 50
                                                              }}
                                                            />
                                                            <p className="sc-6d1fb138-29 sc-2c63d76-3 gBebUF bVyfAz">
                                                              {" "}
                                                            </p>
                                                            <p />
                                                          </div>
                                                        </td>
                                                        <td className="sc-28414bad-6 fYxTuN td">
                                                          <div className="sc-28414bad-7 gcojaQ">
                                                            <p className="sc-6d1fb138-29 sc-2c63d76-3 gBebUF bVyfAz" />
                                                          </div>
                                                        </td>
                                                        <td className="sc-28414bad-6 fYxTuN td">
                                                          <div className="sc-28414bad-7 gcojaQ">
                                                            <p className="sc-6d1fb138-29 sc-2c63d76-3 gOuLUc bVyfAz" />
                                                            <div
                                                              className="sc-51ef7276-0 hFuWPD"
                                                              style={{
                                                                textDecoration:
                                                                  "none",
                                                                color:
                                                                  "rgb(24, 23, 28)"
                                                              }}
                                                            />
                                                            <p />
                                                          </div>
                                                        </td>
                                                        <td className="sc-28414bad-6 fYxTuN td">
                                                          <div className="sc-28414bad-7 gcojaQ" />
                                                        </td>
                                                      </tr>
                                                      <tr
                                                        className="sc-28414bad-5 eFvJIQ"
                                                        style={{
                                                          borderBottom:
                                                            "1px solid rgb(228, 227, 232)"
                                                        }}
                                                      >
                                                        <td
                                                          colSpan={1}
                                                          className="sc-28414bad-6 fYxTuN text-center"
                                                        >
                                                          <div className="sc-28414bad-7 gcojaQ">
                                                            {" "}
                                                          </div>
                                                        </td>
                                                        <td
                                                          className="sc-28414bad-6 fYxTuN td"
                                                          colSpan={5}
                                                        >
                                                          <div className="sc-28414bad-7 gcojaQ">
                                                            <div
                                                              color="#18171C"
                                                              fontSize="14px"
                                                              fontWeight={600}
                                                              className="sc-51ef7276-0 gsggbS"
                                                            >
                                                              SubTotal
                                                            </div>
                                                          </div>
                                                        </td>
                                                        <td
                                                          colSpan={1}
                                                          className="sc-28414bad-6 fYxTuN text-center"
                                                        >
                                                          <div className="sc-28414bad-7 gcojaQ" />
                                                        </td>
                                                      </tr>
                                                      <tr className="sc-28414bad-5 jAESol">
                                                        <td
                                                          colSpan={1}
                                                          className="sc-28414bad-6 fYxTuN text-center"
                                                        >
                                                          <div className="sc-28414bad-7 gcojaQ">
                                                            {" "}
                                                          </div>
                                                        </td>
                                                        <td
                                                          className="sc-28414bad-6 fYxTuN td"
                                                          colSpan={5}
                                                        >
                                                          <div className="sc-28414bad-7 gcojaQ">
                                                            <div
                                                              color="#18171C"
                                                              fontSize="14px"
                                                              fontWeight={600}
                                                              className="sc-51ef7276-0 gsggbS"
                                                            >
                                                              Total
                                                            </div>
                                                          </div>
                                                        </td>
                                                        <td
                                                          colSpan={1}
                                                          className="sc-28414bad-6 fYxTuN text-center"
                                                        >
                                                          <div className="sc-28414bad-7 gcojaQ" />
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        width="100$"
                                        className="sc-f87886bd-0 gsdjwy"
                                      >
                                        <div
                                          width="100%"
                                          height="inherit"
                                          className="sc-51ef7276-0 hZRPfL"
                                        >
                                          <div className="sc-8012e1eb-2 fbPsXa">
                                            <div className="sc-9b97bd27-0 eqCCIw">
                                              <div className="sc-51ef7276-0 fpUbFa">
                                                <div
                                                  id="proposalInfo-title-text"
                                                  className="sc-ce447d5d-1 jtwkdv sc-886f27c5-0 bhOrGf"
                                                >
                                                  <div
                                                    spellCheck="true"
                                                    className="sc-ce447d5d-2 fsmvhR"
                                                    data-slate-editor="true"
                                                    data-slate-node="value"
                                                    contentEditable="false"
                                                    zindex={-1}
                                                    style={{
                                                      position: "relative",
                                                      outline: "none",
                                                      whiteSpace: "pre-wrap",
                                                      overflowWrap: "break-word"
                                                    }}
                                                  >
                                                    <h3
                                                      data-slate-node="element"
                                                      style={{
                                                        fontFamily: "Roboto",
                                                        fontSize: 32
                                                      }}
                                                    >
                                                      <span data-slate-node="text">
                                                        <span
                                                          data-slate-leaf="true"
                                                          className="sc-5fc0b980-0 fSzefS"
                                                          style={{
                                                            color: "inherit"
                                                          }}
                                                        >
                                                          <strong
                                                            style={{
                                                              color: "inherit"
                                                            }}
                                                          >
                                                            <span data-slate-string="true">
                                                              Payment Terms
                                                            </span>
                                                          </strong>
                                                        </span>
                                                      </span>
                                                    </h3>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                display="none"
                                                className="sc-51ef7276-0 dzunQi"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div style={{ width: 1, height: 1 }} />
                              </div>
                            </div>
                          </div>
                        </cord-presence-observer>
                        <cord-presence-observer
                          buffer-events="false"
                          location='{"section":"livepod","component":"attachment-attachment-d3532780-4fde-4d2a-b201-2a2e4e3d29dc"}'
                        >
                          <div
                            id="attachment-d3532780-4fde-4d2a-b201-2a2e4e3d29dc"
                            className="sc-b8209179-0 sc-38009e75-0 cVUigE"
                            style={{ marginBottom: "2rem" }}
                          >
                            <div className="sc-b8209179-1 sc-38009e75-1 jcukRr">
                              <div className="sc-746af168-0 iTDpHh widget-container">
                                <div style={{ width: 1, height: 1 }} />
                                <div className="sc-84a51cd3-1 lfqbuV">
                                  <div className="sc-51ef7276-0 hFuWPD">
                                    <div className="sc-4b437926-0 hfMyLE">
                                      <div
                                        className="sc-76ec0e49-3 gRhSJE"
                                        style={{ width: "auto" }}
                                      >
                                        <button className="sc-4b437926-1 gxPKtz">
                                          <img
                                            src="https://trumpetassets.s3.eu-west-2.amazonaws.com/JPG.svg"
                                            className="sc-4b437926-5 cZQrxN"
                                          />
                                        </button>
                                      </div>
                                      <div className="sc-4b437926-7 cHRBmE">
                                        <div className="sc-4b437926-8 gJAKLn">
                                          <button
                                            role="button"
                                            className="sc-775e4232-2 jUazoY"
                                          >
                                            <span className="sc-775e4232-1 dnHXzw">
                                              DOWNLOAD
                                            </span>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div style={{ width: 1, height: 1 }} />
                              </div>
                            </div>
                          </div>
                        </cord-presence-observer>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <cord-sidebar
              buffer-events="false"
              open="true"
              show-close-button="true"
              show-presence="false"
              show-launcher="false"
              show-all-activity="true"
              exclude-viewer-from-presence="false"
              show-pins-on-page="true"
            />
            <div data-velt-comment-disabled className="sc-2c995c68-0 YzVBN">
              <div
                className="sc-51ef7276-0 hFuWPD"
                style={{ position: "absolute", top: 15, left: 15 }}
              >
                <a
                  href="https://www.sendtrumpet.com/terms#privacy-policy"
                  className="sc-2c995c68-2 IrHVK"
                >
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: 11,
                      color: "rgb(2, 1, 42)",
                      textDecoration: "underline",
                      paddingRight: "0.2rem",
                      paddingLeft: "0.2rem"
                    }}
                  >
                    Privacy Policy
                  </span>
                </a>
              </div>
              <div  className="sc-2c995c68-1 kIImSa">
                <a
                  href="https://www.sendtrumpet.com?ref=pod"
                  target="_blank"
                  className="sc-2c995c68-2 IrHVK"
                >
                  <svg
                    width={56}
                    height={31}
                    viewBox="0 0 56 31"
                    fill="none"
                    className="sc-2c995c68-3 kreiyU"
                    style={{ marginRight: 15 }}
                  >
                    <path
                      d="M9.4153 10.3941C8.97752 10.3938 8.544 10.48 8.13959 10.6475C7.73518 10.8151 7.36783 11.0608 7.05859 11.3706C6.74936 11.6803 6.50432 12.048 6.33752 12.4526C6.17072 12.8572 6.08544 13.2907 6.08657 13.7284L6.0986 18.7925H1.97936C1.75083 18.7853 1.52316 18.824 1.30989 18.9064C1.09661 18.9888 0.902088 19.1132 0.73786 19.2723C0.573632 19.4313 0.443054 19.6217 0.353878 19.8322C0.264703 20.0426 0.21875 20.2689 0.21875 20.4974C0.21875 20.726 0.264703 20.9522 0.353878 21.1627C0.443054 21.3732 0.573632 21.5636 0.73786 21.7226C0.902088 21.8817 1.09661 22.0061 1.30989 22.0885C1.52316 22.1709 1.75083 22.2096 1.97936 22.2024H6.10376L6.11751 27.2494C6.12203 28.1292 6.47393 28.9717 7.09666 29.5936C7.7194 30.2154 8.56258 30.5663 9.4428 30.5699L30.3638 30.6008H30.3724C31.1478 30.6008 31.9156 30.4482 32.632 30.1515C33.3484 29.8549 33.9994 29.4201 34.5477 28.872C35.096 28.324 35.5309 27.6733 35.8277 26.9572C36.1244 26.241 36.2771 25.4735 36.2771 24.6984C36.2771 23.9233 36.1244 23.1557 35.8277 22.4396C35.5309 21.7235 35.096 21.0728 34.5477 20.5247C33.9994 19.9766 33.3484 19.5419 32.632 19.2452C31.9156 18.9486 31.1478 18.7959 30.3724 18.7959H9.51154L9.49779 13.8142L36.9147 13.8486C42.7583 15.5348 48.0134 18.8218 52.0856 23.3379C52.2509 23.5209 52.453 23.667 52.6786 23.7668C52.9043 23.8665 53.1484 23.9176 53.3951 23.9168C53.6085 23.9169 53.82 23.8773 54.0189 23.8C54.349 23.6719 54.6327 23.4473 54.8332 23.1556C55.0337 22.8639 55.1416 22.5185 55.1428 22.1646V2.13132C55.1428 1.77677 55.0353 1.43055 54.8345 1.1383C54.6337 0.846058 54.3489 0.621513 54.0179 0.494276C53.6868 0.367038 53.325 0.343082 52.98 0.425567C52.6351 0.508052 52.3232 0.693103 52.0856 0.956323C50.5821 2.62561 48.9084 4.13344 47.0916 5.45531C44.0292 7.68438 40.6033 9.36584 36.9662 10.425L9.4153 10.3941ZM30.381 22.2024C30.8743 22.2016 31.3568 22.3472 31.7672 22.6207C32.1777 22.8942 32.4977 23.2834 32.6868 23.7389C32.8758 24.1944 32.9253 24.6958 32.829 25.1794C32.7327 25.6631 32.4949 26.1073 32.1459 26.4557C31.9151 26.6889 31.6402 26.8739 31.3372 26.9998C31.0342 27.1257 30.7091 27.1901 30.381 27.1892L9.54419 27.1583L9.52013 22.1955L30.381 22.2024ZM51.735 18.1741C50.8929 17.432 50.02 16.73 49.116 16.068C46.9759 14.5102 44.6707 13.1927 42.242 12.1394C44.6706 11.0858 46.9758 9.76832 49.116 8.2107C50.0182 7.54934 50.8964 6.83644 51.735 6.10293V18.1741Z"
                      fill="#F54966"
                    />
                  </svg>
                  powered by trumpet
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  </div>
  <iframe
    allow="join-ad-interest-group"
    data-tagging-id="AW-11410218781"
    data-load-time={1704310726020}
    height={0}
    width={0}
    style={{ display: "none", visibility: "hidden" }}
    src="https://td.doubleclick.net/td/rul/11410218781?random=1704310726009&cv=11&fst=1704310726009&fmt=3&bg=ffffff&guid=ON&async=1&gtm=45be3bt0v9170951154&gcd=11l1l1l1l1&dma=0&u_w=1512&u_h=982&url=https%3A%2F%2Ftrumpet.app%2Fpods%2F6578210b6f9968c763e6fa3e%2Flive&hn=www.googleadservices.com&frm=0&tiba=Google%20Deal&auid=763342921.1704310726&fledge=1&uaa=arm&uab=64&uafvl=Not_A%2520Brand%3B8.0.0.0%7CChromium%3B120.0.6099.109%7CGoogle%2520Chrome%3B120.0.6099.109&uamb=0&uap=macOS&uapv=12.5.1&uaw=0&data=event%3Dgtag.config"
    cord_iframe_id={0}
  />
  <next-route-announcer>
    <p
      aria-live="assertive"
      id="__next-route-announcer__"
      role="alert"
      style={{
        border: 0,
        clip: "rect(0px, 0px, 0px, 0px)",
        height: 1,
        margin: "-1px",
        overflow: "hidden",
        padding: 0,
        position: "absolute",
        width: 1,
        whiteSpace: "nowrap",
        overflowWrap: "normal"
      }}
    />
  </next-route-announcer>
  <div
    id="rbd-announcement-1"
    aria-live="assertive"
    aria-atomic="true"
    style={{
      position: "absolute",
      width: 1,
      height: 1,
      margin: "-1px",
      border: 0,
      padding: 0,
      overflow: "hidden",
      clip: "rect(0px, 0px, 0px, 0px)",
      clipPath: "inset(100%)"
    }}
  />
  <div id="rbd-hidden-text-1-hidden-text-3" style={{ display: "none" }}>
    Press space bar to start a drag. When dragging you can use the arrow keys to
    move the item around and escape to cancel. Some screen readers may require
    you to be in focus mode or to use your pass through key
  </div>
  <div id="__CORD-ACTION-MODAL__" className="cord-component" />
</>

  )
}


const cardsData = [
  { 
    id: 1, 
    title: 'Title', 
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit', 
    imageUrl: 'https://i.imgur.com/BoOgXH7_d.webp?maxwidth=520&shape=thumb&fidelity=high', // Replace with your image path
    bgColor: 'white'
  },
  { 
    id: 2, 
    title: 'Title', 
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit', 
    imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQqRlq6KmANh_mabwWMj3xlLzJzp3Zq7nPNjHGnguHZvA&s', // Replace with your image path
    bgColor: 'white'
  },
  { 
    id: 3, 
    title: 'Title', 
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit', 
    imageUrl: 'https://img.freepik.com/premium-photo/female-android-robot-head-with-white-metal-wires-face-closeup-creative-ai-high-quality-photo_965671-229.jpg', // Replace with your image path
    bgColor: 'white'
  },
  { 
    id: 4, 
    title: 'Title', 
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit', 
    imageUrl: 'https://ae01.alicdn.com/kf/Sb45a907e8dd94e82997da1dfc776a1bag/Hot-Sale-1-6th-Luke-High-Quality-Male-Head-Sculpture-Carving-Model-For-12inch-Action-Figure.jpg', // Replace with your image path
    bgColor: 'white'
  },
  // ... add other cards
];

const Card = ({ title, description, imageUrl, bgColor }) => (
  <div style={{
    backgroundColor: bgColor,
    width: '250px', // Adjust width as per your design
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    margin: '10px',
    fontFamily: '"Arial", sans-serif', // Use the font from your design
  }}>
    <img src={imageUrl} alt={title} style={{ width: '100%', display: 'block' }} />
    <div style={{ padding: '15px' }}>
      <h1 style={{
        margin: '0 0 10px',
        fontSize: '18px', // Adjust font-size as per your design
        color: '#333', // Adjust title color as per your design
      }}>{title}</h1>
      <p style={{
        margin: 0,
        fontSize: '14px', // Adjust font-size as per your design
        color: '#666', // Adjust paragraph color as per your design
      }}>{description}</p>
    </div>
  </div>
);

const CardsList = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    padding: '10px',
    marginTop: '160px'
    // Add more styling as necessary
  }}>
    {cardsData.map(card => (
      <Card key={card.id} {...card} />
    ))}
  </div>
);


